import { render, staticRenderFns } from "./CommonTransfer.vue?vue&type=template&id=7cf24438&scoped=true&"
import script from "./CommonTransfer.vue?vue&type=script&lang=js&"
export * from "./CommonTransfer.vue?vue&type=script&lang=js&"
import style0 from "./CommonTransfer.vue?vue&type=style&index=0&id=7cf24438&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf24438",
  null
  
)

export default component.exports